window.$ = window.jQuery = require('jquery');

require('jquery-mask-plugin');
require('./common/recaptchaV3.js');
require('./common/validator.js');
require('./common/inputPassword.js');
require('./common/currentLocale.js');
require('./common/populateSelectFromAjax');
require('./common/storageUrl');

require('./components/header.js');

require('select2');
require('select2/dist/css/select2.min.css');
